import type { CalendarEvent } from "@shared/schema";

type CalendarColor = { color: string | null };

/**
 * Resolves the calendar-owned color for event chips. Provider calendars own
 * external event colors; local events use their selected internal calendar.
 * Older local events without a calendar retain their per-event color.
 */
export function resolveCalendarEventColor(
  event: CalendarEvent,
  internalCalendars: Map<string, CalendarColor>,
  externalCalendars: Map<string, CalendarColor>,
): string {
  const internalCalendarId = (event as CalendarEvent & {
    internalCalendarId?: string | null;
  }).internalCalendarId;

  if (event.externalCalendarId) {
    return externalCalendars.get(event.externalCalendarId)?.color || event.color || "#3b82f6";
  }

  if (internalCalendarId) {
    return internalCalendars.get(internalCalendarId)?.color || event.color || "#3b82f6";
  }

  return event.color || "#3b82f6";
}